import React from "react";
import { useMsal } from "@azure/msal-react";
import { loginRequest } from "../authConfig";
import { Button } from "@mui/material";
import LoginIcon from '@mui/icons-material/Login';

export const LoginButton = () => {
    const { instance } = useMsal();

    const handleLogin = (loginType) => {
        if (loginType === "popup") {
            instance.loginPopup(loginRequest).catch(e => {
                console.error(e);
            });
        } else if (loginType === "redirect") {
            instance.loginRedirect(loginRequest).catch(e => {
                console.error(e);
            });
        }
    }

    return (
        <Button
            variant="contained"
            color="primary"
            startIcon={<LoginIcon />}
            onClick={() => handleLogin("popup")}
            size="large"
        >
            Sign in with Microsoft
        </Button>
    );
};
